/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Learn_C3_DescInputs */

const en_cad_learn_c3_desc = /** @type {(inputs: Cad_Learn_C3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive CADCraft from scripts, the CLI and an MCP client.`)
};

/**
* | output |
* | --- |
* | "Drive CADCraft from scripts, the CLI and an MCP client." |
*
* @param {Cad_Learn_C3_DescInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_learn_c3_desc = /** @type {((inputs?: Cad_Learn_C3_DescInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Learn_C3_DescInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_learn_c3_desc(inputs)
});
export { cad_learn_c3_desc as "cad.learn.c3_desc" }